export enum timeoutEnum {
  DEFAULT_TIMEOUT = 600,
  VISIBLE_TIMEOUT = 10000,
  SAVE_ON_MEMORY_TIMEOUT = 5000,
  RELOAD_TIMEOUT = 500,
  RESET_TIMEOUT = 100,
  ONE_MINUTES = 60000,
  INCREMENT_COUNTER = 60,
  TWO_MINUTES = 2 * ONE_MINUTES,
  FOUR_MINUTES = 4 * ONE_MINUTES,
  FIVE_MINUTES = 5 * ONE_MINUTES,
  HALF_SECONDS = RELOAD_TIMEOUT,
  THREE_SECONDS = 3000,
}
